import {
  CompletePageConditionalRuleGroupType,
  CompletePageConditionalRuleModel,
} from '@/domain/model/forms'
import { FormAddConditionCompletePageModel } from '@/pages/FormBuilderSettingsCompletePage/Components/ConditionCompletePage/useAddConditionCompletePageForm'

type Props = {
  formId?: string
  packetId?: string
}

export const transformToCompletePageConditionalRuleModel = (
  data: FormAddConditionCompletePageModel,
  { formId, packetId }: Props
): CompletePageConditionalRuleModel => {
  const conditional_rule_groups: CompletePageConditionalRuleGroupType[] =
    data.conditional_rule_groups.map((group) => {
      return {
        conditional_rules: group.conditional_rules.map((rule) => {
          let expected_answer = (rule?.expected_answer || undefined) as
            | string
            | string[]
            | undefined

          if (Array.isArray(rule.expected_answer)) {
            expected_answer = rule.expected_answer.join(',')
          }
          return {
            question: rule.question,
            expected_answer,
            operator: rule.operator,
          }
        }),
      }
    })

  let redirect_url = null
  let custom_complete_page = null
  const hasCompletePage = Boolean(data.complete_page)
  const hasUrl = Boolean(data.url)

  if (data.if_met === 'custom_page') {
    custom_complete_page = data.complete_page

    if (!hasCompletePage) {
      custom_complete_page = 'default'
    }
  }
  if (hasUrl && data.if_met === 'redirect_url') {
    redirect_url = data.url
  }

  return {
    order: data.order || null,
    form: formId,
    packet: packetId,
    conditional_rule_groups,
    enabled: data.enabled || false,
    is_new: data.is_new || false,
    is_updated: !data.is_new,
    id: data.id,
    custom_complete_page,
    redirect_url,
  }
}
